<template>
    <div class="box-login over-inherit mx-auto mt-5 py-4">
        <div class="box-icon-login text-center"><i class="login-personaje icon-usuario-1 d-inline-flex align-items-center justify-content-center rounded-circle bg-morado-base texto-blanco font-36"></i></div>
        <h2 class="texto-blanco my-4 text-center">Cambia tu contraseña</h2>
        <div class="form-group bg-blanco radio-8 mb-0">
            <input class="form-control-login text-center w-100" v-model="$v.password.$model" type="password" placeholder="Ingresa tu nueva contraseña">
        </div>
        <div class="font-10 texto-blanco text-center font-italic mt-1" v-show="$v.password.$error">Ingrese su nueva contraseña</div>
        <div class="font-10 texto-blanco text-center font-italic mt-1" v-show="!$v.password.minLength">Su contraseña debe tener mínimo 4 caracteres</div>
        <button v-on:click="changePassword" class="btn btn-lg w-100 btn-morado-base texto-blanco px-4 radio-8 mt-3" type="submit">Cambiar</button>
    </div>
</template>
<script>
    import { modalnotificaciones } from '@resources/helpers.js'
    import { required, minLength } from '@public/validators.min'
    export default {
        data (){
            return {
                password: ''
            }
        },
        validations: {
            password: { required, minLength: minLength(4) },
        },
        methods: {
            changePassword () {
                let titulomodal = 'Aviso'
                let self = this
                self.$v.$touch()
                if (self.$v.$invalid) {
                    modalnotificaciones(titulomodal, 'Complete los campos obligatorios')
                } else {
                    axios
                        .post('cambiarcontrasena',{
                            token: document.querySelector("#token_reset").value,
                            password: self.password
                        })
                        .then(response => {
                            Object.assign(this.$data, this.$options.data.call(this))
                            self.$v.$reset()
                            modalnotificaciones(titulomodal, 'Su contraseña ha sido actualizada')
                        })
                        .catch(error => {
                            let codeerror = error.response.status
                            if(codeerror === 400){
                                modalnotificaciones(titulomodal, 'No se encontró el correo electrónico o el enlace ya ha expirado.')
                            }else{
                                modalnotificaciones(titulomodal, 'Verifique los campos del formulario')
                            }
                        })
                        .finally()
                }
            }
        }
    }
</script>
